import { useMemo } from 'react';
import { useAuthStore } from '../../stores/authStore';
import { authApi } from '../api/auth.api';

/**
 * Permission check: role/scopes are taken from JWT payload (and profile).
 * Does not call GET /auth/users/:id/roles; scopes come from token and user.role.
 */
export function usePermission(scope: string): boolean {
  const { user } = useAuthStore();

  return useMemo(() => {
    if (!user) return false;

    // Admin by role name (from profile / JWT)
    let roleName: string | null = null;
    if (typeof user.role === 'string') roleName = user.role;
    else if (user.role && typeof user.role === 'object' && 'name' in user.role)
      roleName = user.role.name;
    if (roleName === 'admin' || roleName === 'Admin') {
      return true;
    }

    // Scopes from profile role object (if backend sends role with scopes)
    let userScopes: string[] =
      typeof user.role === 'object' && user.role?.scopes ? user.role.scopes : [];
    // Scopes from JWT payload (backend puts scopes in token)
    if (userScopes.length === 0) {
      userScopes = authApi.getScopesFromToken();
    }
    return userScopes.includes(scope) || userScopes.includes('*') || userScopes.includes('*:*');
  }, [user, scope]);
}
